import { render } from "./Game.vue?vue&type=template&id=342d18eb"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=342d18eb&scss=true&lang=css"

import exportComponent from "D:\\Project\\skin-web\\圣剑之刃\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__